import { useRef } from 'react';
/**
 * Returns a persistent value initialized once.
 * @function useValue
 * @since 1.0.0
 */
export function useValue(initial) {
    const reference = useRef(undefined);
    if (reference.current === undefined) {
        reference.current = initial();
    }
    return reference.current;
}
